import React from 'react';
import useDrawingMaterials from 'components/quote_builder_widget/hooks/useDrawingMaterials';

const DrawingMaterialChooser = ({ widgetIdentifier, drawingId, onMaterialChange }) => {
  const { materials, selectedMaterialId, handleChange, shouldRender } = useDrawingMaterials(
    widgetIdentifier,
    drawingId,
    onMaterialChange
  );

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="mb-3" data-widget-element="form-group">
      <div className="input-group">
        <span className="input-group-text font13" data-widget-element="label">
          {t('quote_builder.carton_material')}
        </span>
        <select
          name="carton_material_user_price_id"
          value={selectedMaterialId || ''}
          onChange={handleChange}
          className="form-select form-control text-align-right"
          data-widget-element="select"
        >
          {materials.map((material) => (
            <option key={material.id} value={material.id}>
              {material.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DrawingMaterialChooser;
